/* unplugin-vue-components disabled */import { ElTooltip as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/tooltip/style/css';
import { ElCheckbox as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = {
  class: "marginL10"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'channelCheck',
  props: {
    channel: {
      type: Object,
      default: () => ({})
    },
    selectedIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['change'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const checked = computed(() => {
      return props.selectedIds.includes(props.channel.id);
    });
    const emits = __emit;
    const handleChange = () => {
      emits('change', props.channel);
    };
    return (_ctx, _cache) => {
      const _component_el_checkbox = __unplugin_components_0;
      const _component_el_tooltip = __unplugin_components_1;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_checkbox, {
        disabled: __props.channel.status == 1,
        modelValue: _unref(checked),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(checked) ? checked.value = $event : null),
        onChange: handleChange
      }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_tooltip, {
        placement: "top"
      }, {
        content: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(__props.channel.name), 1)]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString(__props.channel.name), 1)]),
        _: 1
      })]);
    };
  }
});